import styled from 'styled-components';

interface IOverviewSectionProps {
  overviewData: {
    summary: {
      label: string;
      value: string;
    };
    details: { label: string; value: string }[];
  };
  location: {
    label: string;
    value: string;
  };
  reportId: string;
}

const OverviewSection = ({ overviewData, location, reportId }: IOverviewSectionProps) => {
  const { summary, details } = overviewData;
  return (
    <Wrapper>
      <div className="top-section">
        <div className="sub-heading-wrapper">
          <div className="sub-heading-label-wrapper">
            <span className="sub-heading-label">{location.label}</span>
            <span className="sub-heading-value">{location.value}</span>
          </div>
          <div className="report-id">{reportId}</div>
        </div>
        <div className="details-wrapper">
          {details.map((detail, idx) => (
            <div className="detail-col" key={idx}>
              <div className="detail-label">{detail.label}</div>
              <div className="detail-value">{detail.value}</div>
            </div>
          ))}
        </div>
      </div>
      {summary?.label && summary?.label !== '' ? (
        <>
          <div className="title">{summary?.label}</div>
          <div className="content-wrapper">
            <div className="content">{summary?.value}</div>
          </div>
        </>
      ) : null}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.widget.background};
  border-radius: 8px;
  padding: 24px;
  color: ${({ theme }) => theme.text};
  margin-bottom: 25px;

  .top-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 24px;
  }

  .detail-col {
    display: flex;
    flex-direction: column;
    min-width: 180px;
  }

  .detail-label {
    font-size: 13px;
    color: ${({ theme }) => theme.text};
    margin-bottom: 4px;
  }

  .detail-value {
    font-size: 20px;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    margin-top: 0px;
    color: ${({ theme }) => theme.text};
  }

  .content-wrapper {
    background: ${({ theme }) => theme.body};
    border-radius: 6px;
    padding: 16px;
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
  }

  .content {
    font-size: 16px;
    color: ${({ theme }) => theme.text};
  }
  .sub-heading-label-wrapper {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: baseline;
    .sub-heading-label {
      font-size: 14px;
      color: ${({ theme }) => theme.text};
    }
    .sub-heading-value {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.text};
    }
  }
  .details-wrapper {
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    gap: 14px;
    .detail-col {
      min-width: 180px;
    }
  }
  .report-id {
    font-size: 22px;
    color: ${({ theme }) => theme.text};
    margin-bottom: 4px;
    font-weight: 600;
  }
`;

export default OverviewSection;
